import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowUpRight } from 'lucide-react';
import { events } from '../mock';
import { ProgramCard } from './ProgramCard';
import api from '../lib/api';

const Events = () => {
  const [live, setLive] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const feat = await api.get('/programs/featured', { params: { limit: 6 } });
        let data = feat.data || [];
        if (data.length === 0) {
          const up = await api.get('/programs', { params: { limit: 6 } });
          data = up.data || [];
        }
        setLive(data);
      } catch { setLive([]); }
    };
    load();
  }, []);

  const useLive = live.length > 0;

  return (
    <section id="events" className="relative py-20 md:py-28 bg-cream-2 overflow-hidden">
      {/* Decorative floral */}
      <div className="pointer-events-none absolute right-10 top-1/2 -translate-y-1/2 w-[520px] h-[520px] opacity-25">
        <BigFloralSVG />
      </div>

      <div className="relative max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-8 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 rounded-full flex items-center justify-center bg-rose-soft">
                <span className="w-3 h-3 rounded-full bg-mahogany" />
              </span>
              <span className="eyebrow">Our Events</span>
            </div>
            <h2 className="font-serif-display text-burgundy text-4xl md:text-6xl leading-[1.05]">
              Upcoming
              <span className="font-italic-display text-rose-italic ml-3">Events / Retreats</span>
            </h2>
          </div>
          <Link to="/events" className="pill-btn">View all Programs <ArrowUpRight className="w-4 h-4" /></Link>
        </div>

        {useLive ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {live.map((p, i) => (
              <div key={p.id} className="fade-up" style={{ animationDelay: `${i * 80}ms` }}>
                <ProgramCard p={p} />
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((ev, i) => (
              <article
                key={ev.id}
                className="group bg-white/70 backdrop-blur-sm rounded-3xl overflow-hidden border border-rose/40 hover:shadow-xl hover:-translate-y-1 transition-all duration-400 fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={ev.image} alt={ev.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute bottom-3 left-3 rounded-full bg-mahogany text-cream text-xs font-medium px-4 py-2 shadow-lg">
                    {ev.date} {ev.month}
                  </div>
                </div>
                <div className="p-6">
                  <div className="text-sm text-mahogany/70 mb-1">Price: <span className="text-burgundy font-medium">{ev.price}</span></div>
                  <h3 className="font-serif-display text-burgundy text-2xl leading-tight mb-4 group-hover:text-rose-italic transition-colors">
                    {ev.title}
                  </h3>
                  <div className="flex flex-col gap-2 text-sm text-burgundy/80">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-rose-italic" />
                      <span>{ev.fullDate}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-rose-italic" />
                      <span>{ev.time}</span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

const BigFloralSVG = () => (
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
    <g fill="#F5C7CD">
      {Array.from({ length: 12 }).map((_, i) => (
        <ellipse
          key={i}
          cx="200"
          cy="120"
          rx="32"
          ry="70"
          transform={`rotate(${i * 30} 200 200)`}
        />
      ))}
      <circle cx="200" cy="200" r="28" fill="#EEB1BA" />
    </g>
  </svg>
);

export default Events;
